// Loaded on every page (as a module so it can share the theme's vendor bundle).
//
// 1. The cart opens/closes as a dropdown from the header (see site-tweaks.css). The theme's own drawer animation
//    slides the panel in from the right; replace it with a plain timer that lasts as long as the CSS dropdown
//    motion, so only the CSS motion is seen and the panel isn't hidden before it finishes lifting up.
// 2. Product photo viewer: no gap between photos while swiping.
import { PhotoSwipeLightbox } from 'vendor';

function holdFor(seconds) {
  var noop = function () {};
  return {
    finished: new Promise(function (resolve) {
      setTimeout(resolve, seconds * 1000);
    }),
    stop: noop,
    cancel: noop,
    finish: noop,
    play: noop,
    pause: noop
  };
}

customElements.whenDefined('cart-drawer').then(function (CartDrawer) {
  CartDrawer.prototype.createEnterAnimationControls = function () {
    return holdFor(0.3);
  };

  CartDrawer.prototype.createLeaveAnimationControls = function () {
    return holdFor(0.3);
  };
});

if (PhotoSwipeLightbox && PhotoSwipeLightbox.prototype && PhotoSwipeLightbox.prototype.loadAndOpen) {
  var originalLoadAndOpen = PhotoSwipeLightbox.prototype.loadAndOpen;
  PhotoSwipeLightbox.prototype.loadAndOpen = function () {
    if (this.options) this.options.spacing = 0;
    return originalLoadAndOpen.apply(this, arguments);
  };
}